import DashboardLayout from "../../components/dashboard/DashboardLayout";
import NotificationsCenterComponent from "../../components/dashboard/NotificationsCenterComponent";

export default function NotificationsCenter() {
  return (
    <DashboardLayout>
      <NotificationsCenterComponent />
    </DashboardLayout>
  );
}
